import { useTranslation } from "react-i18next"
import { useState, useCallback } from "react"
import { Maybe, B2BPaymentMethod, CorePaymentMethod } from "@oysterhr/schema"
import { Text, Alert } from "@oysterhr/ui"
import { hasCreditorId } from "../utils"

interface InfoCreditorsIdAlertProps {
  paymentMethod?: Maybe<CorePaymentMethod | B2BPaymentMethod>
  customerBankAccount?: Maybe<B2BPaymentMethod>
}

export const InfoCreditorsIdAlert = ({
  paymentMethod,
  customerBankAccount,
}: InfoCreditorsIdAlertProps) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/CreditorsIdModal")

  const [bannerShown, setBannerShown] = useState(() => {
    return window.localStorage.getItem("paymentFlow-showCreditorsIDBanner") !== "false"
  })
  const handleCloseBanner = useCallback(() => {
    window.localStorage.setItem("paymentFlow-showCreditorsIDBanner", "false")
    setBannerShown(false)
  }, [])

  if (!bannerShown) return null

  const contractorCreditorId = paymentMethod?.__typename
    ? t(`creditorId.${paymentMethod.__typename}`)
    : null
  const fteCreditorId = customerBankAccount?.__typename
    ? t(`creditorId.${customerBankAccount.__typename}`)
    : null

  const hasContractorCreditorId = paymentMethod ? hasCreditorId(paymentMethod) : false
  const hasFteCreditorId = customerBankAccount ? hasCreditorId(customerBankAccount) : false

  if (!hasContractorCreditorId && !hasFteCreditorId) return null

  return (
    <Alert onRequestClose={handleCloseBanner} variation="info">
      <Alert.Icon />
      <Alert.Content>
        <div>
          <Text>{t("description")}</Text>
          {/* NOTE: If only one exists not both */}
          {hasContractorCreditorId !== hasFteCreditorId ? (
            hasContractorCreditorId ? (
              <Text>{contractorCreditorId}</Text>
            ) : (
              <Text>{fteCreditorId}</Text>
            )
          ) : (
            <>
              <Text>
                {t("contractorCreditorId", {
                  creditorId: contractorCreditorId,
                })}
              </Text>
              <Text>
                {t("fteCreditorId", {
                  creditorId: fteCreditorId,
                })}
              </Text>
            </>
          )}
        </div>
      </Alert.Content>
    </Alert>
  )
}
